import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  IconButton,
  InputLabel,
  Typography,
  Select,
  MenuItem,
} from '@material-ui/core';
import { ExpandMore, Delete } from '@material-ui/icons';
import { genero } from '../../pages/AddEducation/utils';
import { formStyles } from './styles';
import AccordionDeleteWarn from '../AccordionDeleteWarn';
import { AbordagemDetailsObject } from '../../@types/educationTypes';

interface IProps {
  abordagemDetailObject: AbordagemDetailsObject;
  deleteAbordagemDetails: (index: number) => void;
  changeAbordagemDetailState: (viaDetail: AbordagemDetailsObject) => void;
  requiredFields: string[];
}

const AbordagemDetailForm: React.FC<IProps> = ({
  abordagemDetailObject,
  deleteAbordagemDetails,
  changeAbordagemDetailState,
  requiredFields,
}) => {
  const [abordagemDetailsState, setabordagemDetailsState] = useState<
    AbordagemDetailsObject
  >(abordagemDetailObject);
  const [openWarn, setOpenWarn] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const classes = formStyles();

  const handleChange = (key: string, value: string | number) => {
    setabordagemDetailsState({ ...abordagemDetailsState, [key]: value });
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenWarn(!openWarn);
  };

  useEffect(() => {
    setabordagemDetailsState((prev) => {
      return { ...prev, index: abordagemDetailObject.index };
    });
  }, [abordagemDetailObject]);

  return (
    <div className={classes.accordionRow}>
      <Accordion style={{ marginRight: 10, marginBottom: 15, width: '100%' }}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography>{`Abordagem ${abordagemDetailsState.index + 1}`}</Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <div className={classes.label}>
                <InputLabel
                  htmlFor={`data.abordagemDetails[${abordagemDetailsState.index}].tipo`}
                  className={classes.label}
                >
                  Tipo
                </InputLabel>
                <Select
                  variant="outlined"
                  className={classes.select}
                  value={abordagemDetailsState.tipo}
                  onChange={(event) => {
                    handleChange('tipo', event.target.value as string);
                  }}
                  onBlur={() => changeAbordagemDetailState(abordagemDetailsState)}
                >
                  {genero.map((item) => (
                    <MenuItem value={item} key={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>

            <Grid item xs={12} md={6}>
              <div className={classes.inputContainer}>
                <InputLabel
                  htmlFor={`data.abordagemDetails[${abordagemDetailsState.index}].quantidade`}
                  className={classes.label}
                >
                  Quantidade
                </InputLabel>
                <input
                  name="Quantidade"
                  type="number"
                  min={1}
                  step={-1}
                  id={`viaDetails[${abordagemDetailsState.index}].quantidade`}
                  className={`${classes.input} ${
                    requiredFields.includes(`Quantidade ${abordagemDetailsState.index}`)
                      ? classes.errorInput
                      : ''
                  }`}
                  onChange={(event) => {
                    console.log(typeof event.target.value);
                    handleChange('quantidade', +event.target.value);
                  }}
                  onBlur={() => changeAbordagemDetailState(abordagemDetailsState)}
                  value={abordagemDetailsState.quantidade}
                  placeholder="Quantidade"
                />
              </div>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <IconButton
        onClick={handleClick}
        title={`Remover Abordagem ${abordagemDetailsState.index + 1}`}
      >
        <Delete />
      </IconButton>

      <AccordionDeleteWarn
        message={`Remover a Abordagem ${abordagemDetailsState.index + 1}?`}
        open={openWarn}
        setOpen={setOpenWarn}
        index={abordagemDetailsState.index}
        anchorEl={anchorEl}
        deleteItem={() => deleteAbordagemDetails(abordagemDetailsState.index)}
      />
    </div>
  );
};

export default AbordagemDetailForm;
